import {FC, useState} from "react";
import {BlockToggleDescriptionTehnology} from "../../InfoExpand/blockToggleDescriptionTehnology";
import {urlApi, urlApiHttp} from "../../../helper/api";
import {TitleBlockTrend} from "../SidebarCardUI/TitleBlockTrend";
import {ITypeRadar} from "../../../types";
import {
  IDirectionDataSideBar,
  IMetricsData,
} from "../../../pages/Dashboard/Dashboard.type";
import CardItem from "../../CardItem";
import {SidebarTab} from "../../Sidebar";
import {dataMapDirectionFilters} from "../dataMapFilters";
import {BlockFIlteredMap} from "../SidebarCardUI/BlockFIlteredMap";
import {BlockDescription} from "../SidebarCardUI/BlockDescription";
import {TitleCard} from "../styles";
import {MarketScienceCharts} from "../SidebarCardUI/MarketScienceCharts/MarketScienceCharts";
import {MarketScienceChartPanel} from "../SidebarCardUI/MarketScienceCharts/MarketScienceChartPanel";
import {FEATURE_CLUSTER_BATTERY_METRIC_ENABLED} from "../../../config/featureFlags";

interface IProps {
  dataDirection: IDirectionDataSideBar | undefined;
  typeRadar: ITypeRadar;
  handleCardClick: (id: number | string, name: string) => void;

  activeTab: string;
  cpuStep: number;
  sortOption: any;
  handleSortTitle: any;
  handleSort: any;
  colorTitle?: string;
  setIsShowCharts: (value: boolean) => void;
  isShowCharts: boolean;
}

export const SideBarContentMapDirection: FC<IProps> = ({
  dataDirection,
  typeRadar,
  handleCardClick,
  sortOption,
  handleSortTitle,
  handleSort,
  colorTitle,
  setIsShowCharts,
  isShowCharts,
}) => {
  const [isShowTitleParams, setIsShowTitleParams] = useState(true);
  return (
    <>
      <TitleCard color={colorTitle}>{dataDirection?.name}</TitleCard>
      {!isShowCharts ? (
        <>
          {/* <BlockToggleDescriptionTehnology
            data={
              <BlockDescription
                text={dataDirection?.desc}
                image={`${urlApi}/cms/techradar${dataDirection?.image.url}`}
                type="map"
              />
            }
            title={
              <TitleBlockTrend title="ОПИСАНИЕ ТЕХНОЛОГИЧЕСКОГО НАПРАВЛЕНИЯ" />
            }
            typeRadar={typeRadar}
          /> */}
          <BlockDescription
            text={dataDirection?.desc}
            image={
              dataDirection?.image?.url &&
              `${urlApiHttp}/cms/techradar/${dataDirection?.image?.url}`
            }
            type="map"
          />
          <MarketScienceCharts openCharts={() => setIsShowCharts(true)} />
          <BlockFIlteredMap
            handleSortTitle={handleSortTitle}
            handleSort={handleSort}
            sortOption={sortOption}
            dataMapFiltered={dataMapDirectionFilters}
            setIsShowTitleParams={setIsShowTitleParams}
            isShowTitleParams={isShowTitleParams}
          />
          {dataDirection?.clusters.map((item) => {
            return (
              <CardItem
                key={item.id}
                invest_volume_tier={item.invest_volume_tier}
                market_volume_tier={item.market_volume_tier}
                // potentialVolume={item.market_volume}
                title={item.name}
                isFlashFilterEnabled={item.growth_potential}
                isCritical={item.critical}
                isNational={item.national}
                isGpb={item.gpb}
                type={SidebarTab.Clusters}
                onClick={() =>
                  handleCardClick(item.documentId || "", item.name)
                }
                imageCard={item.image?.url}
                imageCardAlt={item.image?.alternativeText || ""}
                isShowTitleParams={isShowTitleParams}
                typeRadar={typeRadar}
                batteryRussia={item.battery_russia || ""}
                batteryWorld={item.battery_world || ""}
                showBattery={FEATURE_CLUSTER_BATTERY_METRIC_ENABLED}
              />
            );
          })}
        </>
      ) : (
        <MarketScienceChartPanel
          dataCharts={dataDirection?.metrics_data || ({} as IMetricsData)}
        />
      )}
    </>
  );
};
